module.exports = __webpack_public_path__ + "static/img/main3-bg-2.932ecfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main3-bg-2.png
// module id = Ajxf
// module chunks = 7